import { Button } from '@partoohub/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ROOT_PATH } from 'app/routing/routeIds';

import { DynamicPlaceholder } from '../DynamicPlaceholder';
import { PlaceholderCategory } from '../DynamicPlaceholder/DynamicPlaceholder.types';

export interface PageNotFoundPlaceholderProps {
    withButton?: boolean;
}

export const PageNotFoundPlaceholder = ({ withButton = false }: PageNotFoundPlaceholderProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const handleRedirect = () => {
        navigate(ROOT_PATH);
    };
    return (
        <DynamicPlaceholder category={PlaceholderCategory.PageNotFound} style={{ margin: 'auto' }}>
            {withButton && (
                <Button dataTrackId="not_found__button" onClick={handleRedirect}>
                    {t('page_not_found_button')}
                </Button>
            )}
        </DynamicPlaceholder>
    );
};
